export default __webpack_public_path__ + "static/media/CNo.36-4.0e6fa016.jpg";